import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

class AuthService {
    constructor() {
        this._token = null;
        this._user = null;
        this.listeners = new Set();

        // مراقبة حالة المصادقة
        onAuthStateChanged(auth, async (user) => {
            this._user = user;
            if (user) {
                this._token = await user.getIdToken();
            } else {
                this._token = null;
            }
            this.notifyListeners();
        });
    }

    // الحصول على توكن المصادقة
    async getIdToken() {
        if (!this._user) {
            throw new Error('لم يتم تسجيل الدخول');
        }
        // تجديد التوكن إذا كان قديماً
        this._token = await this._user.getIdToken(true);
        return this._token;
    }

    // الحصول على المستخدم الحالي
    getCurrentUser() {
        return this._user;
    }

    // إضافة مستمع لتغييرات المصادقة
    addAuthListener(listener) {
        this.listeners.add(listener);
        // استدعاء المستمع مباشرة مع الحالة الحالية
        listener(this._user);
        return () => this.listeners.delete(listener);
    }

    // إخطار جميع المستمعين
    notifyListeners() {
        this.listeners.forEach(listener => listener(this._user));
    }

    // التحقق من صلاحية التوكن
    async verifyToken() {
        try {
            if (!this._user) {
                console.warn('لم يتم تسجيل الدخول');
                return false;
            }

            // تجديد التوكن دائماً للتأكد من صلاحيته
            const token = await this._user.getIdToken(true);
            this._token = token;

            // التحقق من صلاحية التوكن محلياً
            const tokenData = JSON.parse(atob(token.split('.')[1]));
            const expirationTime = tokenData.exp * 1000;
            
            if (Date.now() >= expirationTime) {
                console.warn('انتهت صلاحية التوكن، جاري تجديده...');
                // محاولة تجديد التوكن مرة أخرى
                this._token = await this._user.getIdToken(true);
            }

            // تأكد من وجود الصلاحيات المطلوبة
            if (!tokenData.email || 
                !['boksha@zedorder.com', 'manger@zedorder.com', 'admin@zedorder.com']
                    .includes(tokenData.email)) {
                console.warn('المستخدم ليس لديه الصلاحيات المطلوبة');
                return false;
            }

            return true;
        } catch (error) {
            console.error('خطأ في التحقق من التوكن:', error);
            return false;
        }
    }
}

export const authService = new AuthService();
export default authService;
